module.exports = __webpack_public_path__ + "assets/img/google-play.26d75473.svg";